/*
* Pipeline Theme
*
* Use this file to add custom Javascript to Pipeline.  Keeping your custom
* Javascript in this fill will make it easier to update Pipeline. In order
* to use this file you will need to open layout/theme.liquid and uncomment
* the custom.js script import line near the bottom of the file.
*
*/


(function() {

  // Below are example event listeners.  They listen for theme events that Pipeline
  // fires in order to make it easier for you to add customizations.

  // Keep your scripts inside this IIFE function call to avoid leaking your
  // variables into the global scope.

  var multiGet = function(urls, callback) {
    // number of ajax requests to wait for
    var count = urls.length;

    // results of individual requests get stuffed here
    var results = [];

    // handle empty urls case
    if(count === 0)
    {
      callback(results);
      return;
    }

    urls.forEach(function(url, index)                 {
      pipelineVendor.$.getJSON(url, function(data)
                {
        results[index] = data;
        count = count - 1;

        // are we finished?
        if(count === 0)
        {
          callback(results);
        }
      });
    });
  }
  
  var formatTime = function (date) {
    var hours = date.getHours();
    var minutes = date.getMinutes();
    var ampm = hours >= 12 ? 'pm' : 'am';
    hours = hours % 12;
    hours = hours ? hours : 12; // the hour '0' should be '12'
    minutes = minutes < 10 ? '0'+minutes : minutes;
    var strTime = hours + ':' + minutes + ' ' + ampm;
    return strTime;
  }
//   document.addEventListener('theme:variant:change', function(event) {
//     // You might use something like this to write a pre-order feature or a
//     // custom swatch feature.
//     var variant = event.detail.variant;
//     var container = event.target;
//     if (variant) {
//       console.log('Container ———————— ↓');
//       console.log(container);
//       console.log('Variant —————————— ↓');
//       console.log(variant);
//       // ... update some element on the page
//     }
//   });

//   document.addEventListener('theme:cart:change', function(event) {
//     var cart = event.detail.cart;
//     if (cart) {
//       console.log('Cart ———————————— ↓');
//       console.log(cart);
//       // ... update an app or a custom shipping caluclator
//     }
//   });
//   // Fired when page loads to update header values
//   document.addEventListener('theme:cart:init', (e) => {
//     console.log('theme:cart:init');
//     console.log(e);
//   });

//   // Debounced scroll listeners.  Up and down only fire on direction changes
//   // These events are useful for creating sticky elements and popups.
//   document.addEventListener('theme:scroll', e => { console.log(e); });
//   document.addEventListener('theme:scroll:up', e => { console.log(e); });
//   document.addEventListener('theme:scroll:down', e => { console.log(e); });

//   // Debounced resize listener to bundle changes that trigger document reflow
//   document.addEventListener('theme:resize', e => { console.log(e); });

  // Locks and unlocks page scroll for modals and drawers
  // These are commented out because firing them will lock the page scroll
  // document.dispatchEvent(new CustomEvent('theme:scroll:lock', {bubbles: true}));
  // document.dispatchEvent(new CustomEvent('theme:scroll:unlock', {bubbles: true}));


  // ^^ Keep your scripts inside this IIFE function call to avoid leaking your
  // variables into the global scope.
  
  var $productRows = pipelineVendor.$('.product-tabs .product-row');  
  var deliveryMethod = localStorage.getItem('deliveryMethod') || 'pickup';
  var currentLocation = localStorage.getItem('currentLocation') || null;
  var currentZip = localStorage.getItem('currentZip') || null;
  var $featuredImage = pipelineVendor.$(".featured_image");
  var earliest = '';
  if (!currentZip) {
    deliveryMethod = 'pickup';
  }   
  var locationAnnouncement = pipelineVendor.$('[data-popup-location-announcement]');
  var closeLocationModal = function() {
    locationAnnouncement.parent().removeClass('active');
  };
  var openLocationModal = function(e) {
    locationAnnouncement.parent().addClass('active');
    if (e) {
      e.stopPropagation();
    }
  };
  var toggleLocationModal = function(e) {
    locationAnnouncement.parent().toggleClass('active');
    if (e) {
      e.stopPropagation();
    }
  };
  document.addEventListener('theme:menu:open', closeLocationModal);
  document.addEventListener('click', closeLocationModal);
  locationAnnouncement.off('click.modal').on('click.modal', toggleLocationModal);

  function formatPhoneNumber(phoneNumberString) {
    var cleaned = ('' + phoneNumberString).replace(/\D/g, '');
    var match = cleaned.match(/^(\d{3})(\d{3})(\d{4})$/);
    if (match) {
      return '(' + match[1] + ') ' + match[2] + '-' + match[3];
    }
    return null;
  }

  pipelineVendor.$.get('/apps/sunbowl/shopify/locations', function(locations) {
console.log('this is from location app', locations)
    locations = locations.map(function(location) {
      if (location.phone) {
       location.phone =  formatPhoneNumber(location.phone.substr(-10, 10))
      }
      return location;
    });
    if (currentLocation) {
      try {
        currentLocation = JSON.parse(currentLocation);
      } catch (err) {
        currentLocation = null;
      }
    }
    locations = locations.filter(function(location){
      return location.active;
    });
    
    if (!currentLocation) {
      currentLocation = locations.find(l => l && l.name && l.name.indexOf('Quadra') !== -1);
      if (currentLocation) {
        localStorage.setItem('currentLocation', JSON.stringify(currentLocation));        
      }
    } else if (!currentLocation) {
      currentLocation = locations[0];
      localStorage.setItem('currentLocation', JSON.stringify(currentLocation));
    } else {
      var found = locations.find(function(l) {
        return l.id === currentLocation.id;
      });
      if (!found) {
        currentLocation = locations[0];
        localStorage.setItem('currentLocation', JSON.stringify(currentLocation));
      }
    }
    
    var renderLocations = function(distance) {
      if (distance && distance.rows && distance.rows.length  && distance.rows[0].elements) {
        locations = locations.map(function(l, i) {
          var locationIndex = -1;
          for (var j=0;j<distance.destination_addresses.length; j++) {
            if (l.address1.indexOf(distance.destination_addresses[j].split(' ')[0]) !== -1) {
              locationIndex = j;
            }
//             if (distance.destination_addresses[j].replace(/\s+/g, '').toLowerCase().indexOf(l.zip.replace(/\s+/g, '').toLowerCase()) !== -1) {
//               locationIndex = j;
//             }
          }
          console.log("aqui", l, locationIndex);
          if (locationIndex === -1 || distance.rows[0].elements[locationIndex].status !== 'OK') {
            l.distanceText = "200 km"
            l.distanceValue = 201140
          } else {
            l.distanceText = distance.rows[0].elements[locationIndex].distance.text;
            l.distanceValue = distance.rows[0].elements[locationIndex].distance.value;            
          }
          l.currentDistance = parseInt(l.distanceText.split('.')[0].replace(/\D/g,''), 10);
          l.delivers = false;
          l.minimum = 5000;
          l.cutoff = 12;
          l.hours = '';
          l.radius = 0;
          if (l.metadata && l.metadata.hours) {
            l.hours = l.metadata.hours;
          }
          if (l.metadata && l.metadata.radius) {
            var radius = parseInt(l.metadata.radius, 10);
            if (!isNaN(radius) && radius > 0) {
              l.radius = radius;
              l.delivers = l.currentDistance <= radius;
            }
          }
          if (l.metadata && l.metadata.minimum) {
            var minimum = parseInt(l.metadata.minimum, 10);
            if (!isNaN(minimum) && minimum > 0) {
              l.minimum = minimum * 100;
            }
          }
          if (l.metadata && l.metadata.cutoff) {
            var cutoff = parseInt(l.metadata.cutoff, 10);
            if (!isNaN(cutoff) && cutoff > 0) {
              l.cutoff = cutoff;
            }
          }
          return l;
        })
        locations.sort(function(l1,l2) {
          return l1.distanceValue - l2.distanceValue;
        });
        console.log(locations)
        if (deliveryMethod === 'deliver') {
          var nearestLocation = locations.find(l => l.delivers);
          if (!nearestLocation) {
            if (currentLocation) {
              nearestLocation = currentLocation;
            } else {
              nearestLocation = locations[0];
            }
          }
          if (!currentLocation || currentLocation.id !== nearestLocation.id) {
            currentLocation = nearestLocation;
            localStorage.setItem('currentLocation', JSON.stringify(currentLocation));
          }
        }
      } else {
        locations = locations.map(function(l, i) {
          l.distanceText = '';
          l.distanceValue = 0;
          l.currentDistance = -1;
          l.delivers = false;
          l.hours = '';
          if (l.metadata && l.metadata.hours) {
            l.hours = l.metadata.hours;
          }
          return l;
        })
      }
      pipelineVendor.$('[data-section-locations]').each(function() {
        var $this = pipelineVendor.$(this);
        var source = pipelineVendor.$('[data-section-locations-template]').html();
        $this.html(pipelineVendor.Sqrl.render(source, {
          locations: locations,
          currentLocation: currentLocation,
          deliveryMethod: deliveryMethod,
          hidelocation: pipelineVendor.$('[data-section-locations-template]').attr('hideLocation')
        }));        
      });
      pipelineVendor.$('[data-section-page-locations]').each(function() {
        var $this = pipelineVendor.$(this);
        var source = pipelineVendor.$('[data-section-page-locations-template]').html();
        $this.html(pipelineVendor.Sqrl.render(source, {
          locations: locations,
          currentLocation: currentLocation,
          deliveryMethod: deliveryMethod,
          hidelocation: pipelineVendor.$('[data-section-page-locations-template]').attr('hideLocation'),
        }));        
      });
      pipelineVendor.$('[data-section-change-location]').each(function() {
        var $this = pipelineVendor.$(this);
        var source = pipelineVendor.$('[data-section-change-location-template]').html();
        $this.html(pipelineVendor.Sqrl.render(source, {
          locations: locations,
          currentLocation: currentLocation,
          deliveryMethod: deliveryMethod,
             hidelocation: pipelineVendor.$('[data-section-change-location-template]').attr('hideLocation')
        }));        
      });
      pipelineVendor.MicroModal.init({
        openTrigger: `data-popup-change`,
        disableScroll: true,
      });
      var html = '';
      html += '<span>';
      html += '<span class="hidden-md-down">Your Store: </span>';
      html += '<span class="first">';
      html += currentLocation.name;
      html += '</span>';
      html += '<i class="hero_hours">Hours:</i>';      
      html += '<span class="second">';
      html += currentLocation.metadata.hours;
      html += '</span>';
      html += '<a id="chev" class="sam bob chevron--down alice"> <svg width="20" height="20" version="1.1" viewbox="0 0 100 100" xmlns="http://www.w3.org/2000/svg" preserveAspectRatio="xMidYMid"> <g class="chevron__container"> <line class="chevron__line1" x1="10" y1="50" x2="50" y2="50"/> <line class="chevron__line2" x1="90" y1="50" x2="50" y2="50"/> </g> </svg></a>';
      html += '</span>';
      
      locationAnnouncement.html(html);
      pipelineVendor.$('.header-location-wrapper').off('click.modal').on('click.modal', function(e) {
        e.stopPropagation();
      });
      pipelineVendor.$('[data-variant-inventory]').each(function() {
        var $this = pipelineVendor.$(this);
        var variantId = $this.data('variant-inventory');
        var minimum = $this.data('minimum');
        if (!variantId) {
          return;
        }
        var quantity = parseInt(pipelineVendor.$('[data-quantity-input]').val(), 10);       
        if (isNaN(quantity) || quantity <= 0) {
          quantity = 1;
        }
        minimum = quantity + 2;
        pipelineVendor.$.get('/apps/sunbowl/shopify/inventory-levels?id=' + variantId, function(data) {
          console.log('Response from app', data)
          var source = pipelineVendor.$('[data-inventory-template]').html();
          var deliverySource = pipelineVendor.$('[data-delivery-template]').html();
          var locationAvailability = locations.map(function(location) {
            
            var inventory = data.find(function(i) {
              return i.location_id === location.id;
            });
            console.log('thsio', inventory, minimum )
            var count = inventory ? inventory.available : 0;
            return {
              id: location.id,
              name: location.name.toUpperCase(),
              address: location.address1,
              province_code: location.province_code,
              city: location.city,
              zip: location.zip,
              available: inventory && inventory.available && inventory.available >= minimum ? true : false,
              distanceText: location.distanceText,
              distanceValue: location.distanceValue,
              delivers: location.delivers,
              minimum: location.minimum,
              hours: location.hours,
              cutoff: location.cutoff,
              currentDistance: location.currentDistance,
              deliveryMethod: deliveryMethod,
              hidelocation: 'abc'
            }
          });
          var availability = locationAvailability.find(function(l) {
            return l.id === currentLocation.id;
          });
          document.dispatchEvent(
            new CustomEvent('theme:variant:availability', {
              detail: {
                availability: availability,
              },
              bubbles: true,
            })
          );
          $this.html(pipelineVendor.Sqrl.render(source, {
            currentLocation: availability,
            hidelocation:  pipelineVendor.$('[data-inventory-template]').attr('hideLocation'),
            locations: locationAvailability.filter(function(l) {
              return l.id !== currentLocation.id;
            }),
          }));
          pipelineVendor.$('[data-delivery]').each(function() {
            if (deliveryMethod === 'pickup') {
              pipelineVendor.$(this).html('');              
            } else {
              pipelineVendor.$(this).html(pipelineVendor.Sqrl.render(deliverySource, {
                currentLocation: availability,
                currentZip: currentZip
              }));
            }
          })
        })
      });
      
      pipelineVendor.$('[data-cart-locations]').each(function () {
        var $this = pipelineVendor.$(this);
        pipelineVendor.$.getJSON('/cart.js', function (cart) { 
          if (!cart.items.length) {
            return;
          }
          var source = pipelineVendor.$('[data-inventory-template]').html();
          var deliverySource = pipelineVendor.$('[data-delivery-template]').html();
          var checkoutSource = pipelineVendor.$('[data-checkout-template]').html();
          var urls = [];
          for (var i=0; i<cart.items.length; i++ ) {
            urls.push('/apps/sunbowl/shopify/inventory-levels?id=' + cart.items[i].variant_id);
          }
          multiGet(urls, function(datas) {
            var locationAvailability = locations.map(function(location) {
              var available = true;
              for (var i=0; i<datas.length; i++) {
                var data = datas[i];
                var inventory = data.find(function(i) {
                  return i.location_id === location.id;
                })
                var $div = pipelineVendor.$('[data-variant-availability='+cart.items[i].variant_id+']');
           
              
                var threshold = cart.items[i].quantity + 2;
       
      
                if (location.id === currentLocation.id) {
        
           
                  if (inventory.available >= threshold) {
    
                    $div.html('').removeClass('errors');
                  } else {
    
                    $div.html('This product, in this quantity, is not available at ' + currentLocation.name +' at this time. Lower quantity or check availability for pickup.').addClass('errors');
                  }
                }
              }
              
              return {
                id: location.id,
                name: location.name.toUpperCase(),
                address: location.address1,
                province_code: location.province_code,
                city: location.city,
                zip: location.zip,
                available: $('.errors[data-minimum="3"]').length > 0 ? false : true,
                distanceText: location.distanceText,
                distanceValue: location.distanceValue,
                delivers: location.delivers,
                minimum: location.minimum,
                cutoff: location.cutoff,
                hours: location.hours,
                currentDistance: location.currentDistance,
                deliveryMethod: deliveryMethod,
         
              }
            });
            console.log('this hit', locationAvailability);
            var availability = locationAvailability.find(function(l) {
              return l.id === currentLocation.id;
            });
            $this.html(pipelineVendor.Sqrl.render(source, {
              currentLocation: availability,
              locations: locationAvailability.filter(function(l) {
                return l.id !== currentLocation.id;
              }),
            }));
            pipelineVendor.$('[data-cart-delivery]').each(function() {
              if (deliveryMethod === 'pickup') {
                pipelineVendor.$(this).html('');              
              } else {
                pipelineVendor.$(this).html(pipelineVendor.Sqrl.render(deliverySource, {
                  currentLocation: availability,
                  currentZip: currentZip
                }));
              }
            });
            var $checkout = pipelineVendor.$('.checkout__button');
            if (deliveryMethod === 'deliver') {
              var date = new Date();
              date.setHours(availability.cutoff);
              date.setMinutes(0);
              pipelineVendor.$('.cutoff-message').html('Delivery date and time selected at checkout. Orders placed by '+formatTime(date)+' may be delivered same day').show();
            } else {
              pipelineVendor.$('.cutoff-message').html('').hide();              
            }

            if (!availability.available) {
              $checkout.attr('disabled', 'disabled');
              $checkout.addClass('disabled');
              $checkout.html('Check your cart');
            } else {
              if (deliveryMethod === 'deliver' && !availability.delivers) {
                $checkout.attr('disabled', 'disabled');
                $checkout.addClass('disabled');
                $checkout.html('Delivery Not Available');
              } else if (deliveryMethod === 'deliver' && availability.minimum > cart.total_price) {
                $checkout.attr('disabled', 'disabled');
                $checkout.addClass('disabled');
                var money = pipelineVendor.themeCurrency.formatMoney(availability.minimum, theme.moneyFormat);
                $checkout.html('Minimum '+money+' required');
              }else {
                $checkout.attr('disabled', false);
                $checkout.removeClass('disabled');
                $checkout.html('Checkout');
              }
            }
            var date = new Date();
            if(currentLocation.name == "Cascadia Courtenay"){
              if (date.getHours() >= 9) {
                date.setDate(date.getDate() + 1);
              }
            } else {
              if (date.getHours() >= 12) {
                date.setDate(date.getDate() + 1);
              }
            }
            var time = '4 - 7PM';
            if (date.getHours() > currentLocation.cutoff); {
              time = '1 - 4PM';
            }
            var month = date.getMonth() + 1;
            if (month <= 9) {
              month = '0' + month;
            }
            var day = date.getDate();
            if (day <= 9) {
              day = '0' + day;
            }
            earliest = date.getFullYear() + '-' + month + '-' + day;
         
            pipelineVendor.$('[data-confirm-checkout]').html(pipelineVendor.Sqrl.render(checkoutSource, {
              title: deliveryMethod === 'pickup' ? 'Confirm Pickup At' : 'Confirm Delivery From',
              currentLocation: availability,
              deliveryMethod: deliveryMethod,  
              earliest: earliest,
              time: time
            }))

            pipelineVendor.MicroModal.init({
              openTrigger: `data-popup-checkout`,
              disableScroll: true,
              disableFocus: true,
              onShow: function () {


              // Disable orders for Christmas Day (all day) and Christmas Eve (4-7pm)
              if (!window.datePickerInitialized) {
                function christmasEve(date) {
                  const option = $('#delivery-window option[value="4 - 7PM"]')[0];
                  if (/12\/24/.test(date.toLocaleDateString())) {
                    option.setAttribute('disabled', 'disabled');
                    $('#delivery-window').val('1 - 4PM');
                  } else {
                    option.removeAttribute('disabled');
                  }
                }
                const $datePicker = $('#delivery-date').datepicker({
                    minDate: 0,
                    showButtonPanel: true,
                    beforeShowDay: function (date) {
                        return /12\/25/.test(date.toLocaleDateString()) ? [false, " disabled"] : [true, " enabled"];
                    },
                    onSelect: function (date) {
                      christmasEve((new Date(date)));
                    }
                })
                christmasEve((new Date(Date.now()))); // in case today is Christmas Eve
              }
              window.datePickerInitialized = true;



                
              }
            });
			pipelineVendor.$('[data-popup-location]').off('click.modal').on('click.modal', openLocationModal)
          });
        });
      });
    }; 
    
    var pickLocation = function(e) {
      if (pipelineVendor.$('body').data('cart-items') > 0) {
        if (!window.confirm("Are you sure you want to change location? The items in your cart may not be available at new location")) {
          return;
        }
      }
      var $this = pipelineVendor.$(e.target);
      var locationId = $this.data('location-id');
      var location = locations.find(function(l) {
        return l.id === locationId;
      });
      if (location) {
        currentLocation = location;
        deliveryMethod = 'pickup';
        localStorage.setItem('deliveryMethod', deliveryMethod);
        localStorage.setItem('currentLocation', JSON.stringify(currentLocation));
        getDistanceAndRenderLocations();
        pipelineVendor.MicroModal.close();
      }
    };

    
    var getDistanceAndRenderLocations = function() {
      if (currentZip) {
        pipelineVendor.$('.set-my-zip-wrapper').find('input').val(currentZip);
        var destinations = locations.map(function(l) {
          return encodeURIComponent(l.address1 + ' ' + l.city + ' ' + l.province + ' ' + l.country + ' ' + l.zip); 
        }).join('|')
        pipelineVendor.$.get('/apps/sunbowl/shopify/distance?cache=1&origins='+currentZip+'&destinations='+destinations, function(distance) {
          renderLocations(distance);
        });              
      } else {
        renderLocations();
      }
    }
    
    pipelineVendor.$(document).on('click', '.set-my-store', pickLocation);
    pipelineVendor.$('.header-location-wrapper').on('click', '.set-my-store', pickLocation);
    
    
    pipelineVendor.$(document).on('click', '.set-my-zip', function(e) {
      var $this = pipelineVendor.$(e.target);
      var zip = $this.closest('.set-my-zip-wrapper').find('input').val();
      if (zip) {
        currentZip = zip;
        deliveryMethod = 'deliver';
        localStorage.setItem('currentZip', zip);
        localStorage.setItem('deliveryMethod', 'deliver');
        getDistanceAndRenderLocations();
      }
    });
    var timeout = null;
    var setZip = function($this) {
      var zip = $this.val();
      currentZip = zip;
      deliveryMethod = 'deliver';
      localStorage.setItem('currentZip', zip);
      localStorage.setItem('deliveryMethod', 'deliver');
      getDistanceAndRenderLocations();
      timeout = null;
    }    
    pipelineVendor.$('.set-my-zip-wrapper input').on('keyup', function() {
      if (timeout) {
        window.clearTimeout(timeout);
        timeout = null;
      }
      var $this = pipelineVendor.$(this);
      timeout = window.setTimeout(function() {
        setZip($this);
      }, 500);
    });
    
    pipelineVendor.$(document).on('click', '.pickup-checkout', function(e) {
      var attributes = {
        'delivery-date': '',
        'delivery-window': '',
        shipping: 'store-pickup',
        location: currentLocation.name,
        time: new Date().getTime(),
      }
      pipelineVendor.$.post('/cart/update.js', {
        attributes: attributes,
      }, function() {
        window.location.href = '/checkout?step=contact_information';
      },'json');
    })
    
    pipelineVendor.$(document).on('click', '.delivery-checkout', function(e) {


      if(!pipelineVendor.$('#delivery-date').val()) {
        alert("Please select valid date");
        return;
      }
      if (new Date(pipelineVendor.$('#delivery-date').val()).getTime() < new Date(earliest).getTime()) {
        alert("Please select valid date");
        return;
      }

      var d = new Date(pipelineVendor.$('#delivery-date').val()),
      month = '' + (d.getMonth() + 1),
      day = '' + d.getDate(),
      year = d.getFullYear();

      if (month.length < 2) 
          month = '0' + month;
      if (day.length < 2) 
          day = '0' + day;
      var attributes = {
        'delivery-date': [year, month, day].join('-'),
        'delivery-window': pipelineVendor.$('#delivery-window').val(),
        shipping: 'local-delivery',
        location: currentLocation.name,        
        time: new Date().getTime(),
      }
      pipelineVendor.$.post('/cart/update.js', {
        attributes: attributes,
      }, function() {
        window.location.href = '/checkout?step=contact_information';
      },'json');
    })
    
    
    var setDeliveryMethod = function($elem) {
      pipelineVendor.$('.delivery-preference').removeClass('checked');
      $elem.addClass('checked');
      var $parent = $elem.closest('.accordion-toggle');
      var currentZip = localStorage.getItem('currentZip') || null;
      if ($parent.is('.pickup')) {
        deliveryMethod = 'pickup';
      } else if (currentZip) {
        deliveryMethod = 'deliver';
      }
      localStorage.setItem('deliveryMethod', deliveryMethod);
      getDistanceAndRenderLocations();
    }
    pipelineVendor.$('.delivery-preference').on('click', function(e) {
      setDeliveryMethod(pipelineVendor.$(this));
    });
    pipelineVendor.$('.accordion-toggle').on('click', function(e) {
      setDeliveryMethod(pipelineVendor.$(this).find('.delivery-preference'));
    });

    document.addEventListener('theme:variant:change', getDistanceAndRenderLocations);
    document.addEventListener('theme:location:change', getDistanceAndRenderLocations);
    pipelineVendor.$('[data-quantity-input]').on('change', getDistanceAndRenderLocations);
    var cartLoaded = false;
    document.addEventListener('theme:cart:change', function () {
      if (cartLoaded) {
        getDistanceAndRenderLocations();
//         window.location.reload();
      } else {
        cartLoaded = true;
      }
    });
    
    var $deliveryRadio = pipelineVendor.$('.accordion-toggle.' + deliveryMethod);
    if ($deliveryRadio.length) {
      $deliveryRadio.click();
    } else {
      getDistanceAndRenderLocations();
    }
    
    
    $productRows.off('click').on('click', function(e) {
      var $target = pipelineVendor.$(e.currentTarget);
      var $wrapper = $target.closest('.product-single');
      var variant = $target.data('variant');
      if (variant) {
        e.preventDefault();
        $wrapper.find('[data-variant-inventory]').data('variant-inventory', variant);
        $wrapper.find('[name="id"]').val(variant);
        var quantity = parseInt($wrapper.find('.quantity__input').val(), 10)
        var formattedPrice = pipelineVendor.themeCurrency.formatMoney($target.data('price') * quantity, theme.moneyFormat);
        $wrapper.find('.add-to-cart__price').html('<span data-price="'+$target.data('price')+'" data-button-price>' + formattedPrice + '</span>');

        var $productSale = pipelineVendor.$('.product-sale');
        if ($target.data('sale')) {
          $productSale.find('.sale-price').html($target.data('sale'));
          $productSale.removeClass('hidden')
        } else {
          $productSale.addClass('hidden')
        }
        $target.closest('.product-tabs').find('.radio').removeClass('checked');        
        $target.find('.radio').addClass('checked');
        $featuredImage.attr('data-old-srcset', $featuredImage.attr('data-srcset'));

        getDistanceAndRenderLocations();
      }
    });
  }); 
  //SET image on hover for 

  $productRows.mouseenter(function(){

    var $this = pipelineVendor.$(this);

    var hover_image = $this.data("image");

    $featuredImage.attr('data-old-srcset', $featuredImage.attr('data-srcset'));
    $featuredImage.attr('data-srcset', hover_image);

  }).mouseleave(function() {
    var $this = pipelineVendor.$(this);

    var hover_image = $this.data("image");

    if ($featuredImage.attr('data-srcset') !== $featuredImage.attr('data-old-srcset')) {
      $featuredImage.attr('data-srcset', $featuredImage.attr('data-old-srcset'));
    }
  }); 
  var canHover = !(matchMedia('(hover: none)').matches);
  if (canHover) {
    document.body.classList.add('can-hover');
  } else {
    var $elem = pipelineVendor.$('.drawer__menu');
    setInterval(function() {
      if ($elem.css('display') === 'block') {
        $elem.css('display', 'flex');
      } else {
        $elem.css('display', 'block');      
      }
    }, 100);
  }
})();
 


  //Select First Word on Collection Headers 

